import React from "react";
import styled from "styled-components";
import { Loader } from "../Loader/Loader";

type TransitionContainerProps = {
  isLoaded: boolean;
  transitionDuration?: number;
  height?: number;
  extraProps?: string;
};

const TransitionContainer = styled.div<TransitionContainerProps>`
  margin: 0;
  padding: 0;
  max-height: inherit;
  max-width: inherit;
  transition: opacity
    ${({ transitionDuration }) => transitionDuration ?? "0.3"}s ease-out;
  opacity: ${({ isLoaded }) => (isLoaded ? "1" : "0")};
  ${({ height }) => (height ? `height: ${height}px` : "")}

  ${({ extraProps }) => (extraProps ?? "")}
`;

export type TransitionWrapperProps = TransitionContainerProps & {
  children: React.ReactNode;
  useLoader?: boolean;
  useV2?: boolean;
};

export const TransitionWrapper: React.FC<TransitionWrapperProps> = ({
  children,
  isLoaded,
  transitionDuration,
  height,
  useLoader = false,
  extraProps,
}) => (
  <>
    {useLoader && !isLoaded && <Loader />}
    <TransitionContainer
      isLoaded={isLoaded}
      extraProps={extraProps}
      transitionDuration={transitionDuration}
      height={height}
    >
      {children}
    </TransitionContainer>
  </>
);
